import { render, staticRenderFns } from "./OperaLabelsAreaWindow.vue?vue&type=template&id=4b8bd343&scoped=true&"
import script from "./OperaLabelsAreaWindow.vue?vue&type=script&lang=js&"
export * from "./OperaLabelsAreaWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaLabelsAreaWindow.vue?vue&type=style&index=0&id=4b8bd343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8bd343",
  null
  
)

export default component.exports